import React from 'react';
import { createRootRoute, createRoute, createRouter, Outlet, RouterProvider } from '@tanstack/react-router';
import { routes } from '../routes';
import WrappedRoute from './WrappedRoute';
import Layout from 'Layout';

const toTanstackPath = (path = '/', exact = true) => {
    let tanstackPath = path.replace(/:([A-Za-z0-9_]+)/g, '$$$1');
    return tanstackPath;
};

const rootRoute = createRootRoute({
    component: () => (
        <Layout>
            <Outlet />
        </Layout>
    ),
});

const appRoutes = routes.map((config) =>
    createRoute({
        getParentRoute: () => rootRoute,
        path: toTanstackPath(config.route.path || '/', config.route.exact),
        component: () => <WrappedRoute {...config.route} extras={config.extras} render={config.render} />,
    })
);

const routeTree = rootRoute.addChildren(appRoutes);

const router = createRouter({
    routeTree,
});

const Router = () => <RouterProvider router={router} />;

export default Router;
